module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2598837e0a24e0d170ed53318b9b797a.png";